import React from 'react';
import Field from './field';

export default (props) => {
    const { fieldKey, defaultValue, format, prefix } = props;
    const formattedValue = format(defaultValue);

    return(
        <Field
            {...props}
            inputComp={
                <div className="row collapse">
                    <div className="small-1 large-1 columns">
                        <span className="prefix">{ prefix }</span>
                    </div>

                    <div className="small-11 large-11 columns">
                        <input
                            type="text"
                            id={fieldKey}
                            name={fieldKey}
                            defaultValue={formattedValue}
                        />
                    </div>
                </div>
            }
        />
    );
}
